"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Tooltip: true
};
exports.default = exports.Tooltip = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _react = _interopRequireWildcard(require("react"));
var _Popper = require("../utils/_Popper");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _isFunction = require("../utils/isFunction");
var _Tooltip = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Tooltip.css") : void 0);
var _Tooltip2 = require("./Tooltip.types");
Object.keys(_Tooltip2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Tooltip2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Tooltip2[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-tooltip';
/**
 * The **Tooltip** component is a lightweight overlay that contains a short message
 * which provides the user context about an unknown or unfamiliar element in an interface.
 */
const Tooltip = exports.Tooltip = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Tooltip, _props)) : _props;
  const {
      children,
      delay = 0,
      flipContainer,
      id,
      innerContainerProps,
      message,
      placement = ['right', 'top', 'left', 'bottom'],
      showOnLoad,
      targetProps,
      outerPopperProps,
      doNotDescribe
    } = props,
    otherProps = __rest(props, ["children", "delay", "flipContainer", "id", "innerContainerProps", "message", "placement", "showOnLoad", "targetProps", "outerPopperProps", "doNotDescribe"]);
  const classnames = _bind.default.bind(_Tooltip.default);
  const [showTooltip, setShowTooltip] = (0, _react.useState)(showOnLoad);
  const [queueTooltip, setQueueTooltip] = (0, _react.useState)(false);
  let tooltipId = (0, _useUniqueId.default)();
  if (id) {
    tooltipId = id;
  }
  const targetComponent = _react.default.Children.only(children);
  const targetComponentHasRef = targetComponent && /*#__PURE__*/_react.default.isValidElement(targetComponent) && 'ref' in targetComponent;
  const {
    disabled,
    onBlur,
    onFocus,
    onKeyDown,
    onMouseEnter,
    onMouseLeave
  } = targetComponent.props;
  const handleFocus = () => {
    setQueueTooltip(true);
  };
  const handleBlur = () => {
    setShowTooltip(false);
    setQueueTooltip(false);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
    setQueueTooltip(false);
  };
  const handleMouseEnter = () => {
    setQueueTooltip(true);
  };
  let tooltipTimer;
  const startTimer = () => {
    if ((0, _isFunction.isFunction)(setTimeout)) {
      tooltipTimer = setTimeout(() => setShowTooltip(true), delay);
    }
  };
  const clearTimer = () => {
    if ((0, _isFunction.isFunction)(clearTimeout)) {
      clearTimeout(tooltipTimer);
    }
  };
  (0, _react.useEffect)(() => {
    if (queueTooltip) {
      startTimer();
    } else {
      clearTimer();
    }
    return clearTimer;
  }, [queueTooltip]);
  (0, _react.useEffect)(() => {
    if (disabled) {
      setShowTooltip(false);
      setQueueTooltip(false);
    }
  }, [disabled]);
  const handleKeyDown = event => {
    /*
        If the Escape key is pressed when the Tooltip's target has focus
        and the tooltip is visible
        then hide the Tooltip
    */
    if (showTooltip && event.key === 'Escape') {
      event.preventDefault();
      setShowTooltip(false);
    }
  };
  const targetAriaAttributes = {
    'data-tooltip-target': true
  };
  let ariaDescribedby;
  if (showTooltip && !doNotDescribe) {
    ariaDescribedby = [...new Set([tooltipId, targetComponent.props['aria-describedby']])].filter(Boolean).join(' ');
  } else {
    ariaDescribedby = targetComponent.props['aria-describedby'];
  }
  if (ariaDescribedby) {
    targetAriaAttributes['aria-describedby'] = ariaDescribedby;
  }
  const renderTargetComponent = (referenceRef, referenceProps, targetClasses, additionalProps) => /*#__PURE__*/_react.default.cloneElement(targetComponent, Object.assign(Object.assign(Object.assign(Object.assign({}, additionalProps), referenceProps), targetAriaAttributes), {
    ref: (0, _reactMergeRefs.default)([targetComponentHasRef ? targetComponent.ref : null, referenceRef]),
    onBlur: (0, _chainFunction.default)(handleBlur, onBlur),
    onFocus: (0, _chainFunction.default)(handleFocus, onFocus),
    onKeyDown: (0, _chainFunction.default)(handleKeyDown, onKeyDown),
    onMouseEnter: (0, _chainFunction.default)(handleMouseEnter, onMouseEnter),
    onMouseLeave: (0, _chainFunction.default)(handleMouseLeave, onMouseLeave)
  }));
  const classes = classnames(CSS_BLOCK, {
    [`${CSS_BLOCK}--in`]: showTooltip
  });
  return /*#__PURE__*/_react.default.createElement(_Popper.Popper, Object.assign({
    showArrow: true
  }, outerPopperProps, {
    arrowClassName: classnames(`${CSS_BLOCK}__arrow`),
    flipContainer: flipContainer,
    popperClassName: classes,
    popperPlacement: placement,
    popperProps: Object.assign(Object.assign({}, otherProps), {
      id: `${tooltipId}-popper`,
      'aria-live': 'assertive',
      role: 'tooltip',
      innerRef: ref
    }),
    show: !disabled && showTooltip,
    renderTargetComponent: renderTargetComponent,
    targetProps: targetProps
  }), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, innerContainerProps, {
    className: classnames(`${CSS_BLOCK}__inner`, innerContainerProps === null || innerContainerProps === void 0 ? void 0 : innerContainerProps.className),
    id: tooltipId
  }), message));
});
Tooltip.displayName = 'Tooltip';
var _default = exports.default = Tooltip;